// Layout constants for consistent spacing and sizing across the application

// AI Assistant sidebar width (matches w-96 = 384px in Tailwind)
export const AI_ASSISTANT_WIDTH = 384;

// When Copilot is closed, we still reserve a small right gutter so the Copilot
// button doesn't float over content (ChatGPT-like "off to the side" affordance).
export const AI_ASSISTANT_GUTTER_WIDTH = 64;
